import React from 'react';
import { Box, Spinner, Text, VStack, useColorModeValue } from '@chakra-ui/react';

function LoadingSpinner() {
  const textColor = useColorModeValue('gray.600', 'gray.400');

  return (
    <Box
      position="fixed"
      top="0"
      left="0"
      right="0"
      bottom="0"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bg="rgba(255, 255, 255, 0.8)"
      zIndex={9999}
    >
      <VStack spacing={4}>
        <Spinner
          thickness="4px"
          speed="0.65s"
          emptyColor="gray.200"
          color="blue.500"
          size="xl"
        />
        <Text color={textColor} fontSize="lg">
          Loading...
        </Text>
      </VStack>
    </Box>
  );
}

export default LoadingSpinner; 